<template>
  <div id="app">
    <div class="container">
      <div class="wheel-container">
        <LuckyWheelDemo />
      </div>
      <div class="winners-list">
      <div class="title-container">
        <h2>中奖信息</h2>
      </div>
      <ul class="scrolling-list">
        <li
          v-for="(winner, index) in winners"
          :key="index"
          class="winner-item"
        >
          <span class="user-id">{{ winner.userId }}</span>
          <span class="prize">获得 {{ winner.prize }}</span>
        </li>
      </ul>
    </div>
    </div>
  </div>
</template>
<script>
import LuckyWheelDemo from "@/components/Lucky.vue";
export default {
  name: "App",
  components: {
    LuckyWheelDemo,
  },
  data() {
    return {
      winners: [
        { userId: "用户435151xxx", prize: "手机" },
        { userId: "用户789456aaa", prize: "平板" },
        { userId: "用户123654zzz", prize: "优惠券" },
        { userId: "用户124151xxx", prize: "数据线" },
        { userId: "用户233456aaa", prize: "平板" },
        { userId: "用户135654zzz", prize: "耳机" },
        { userId: "用户986551xxx", prize: "优惠券" },
        { userId: "用户2319456aaa", prize: "平板" },
        { userId: "用户132154zzz", prize: "优惠券" },
        // 更多获奖者数据...
      ],  
    };
  },
  mounted() {
    this.startScrolling();
  },
  methods: {
    startScrolling() {
      const scrollingList = document.querySelector(".scrolling-list");
      if (scrollingList) {
        return
      }
      let scrollPosition = 0;
      let scrollingInterval = setInterval(() => {
        scrollPosition -= 10; // 每次滚动10像素
        scrollingList.style.transform = `translateY(${scrollPosition}px)`;
        if (
          scrollPosition <= -(scrollingList.scrollHeight - window.innerHeight)
        ) {
          clearInterval(scrollingInterval);
          scrollPosition = 0;
          scrollingList.style.transform = "translateY(0)";
          setTimeout(() => {
            this.startScrolling(); // 重置后再次启动滚动
          }, 2000); // 重置前等待2秒
        }
      }, 50); // 每50毫秒滚动一次
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: space-between;
}

.wheel-container,
.winners-list {
  flex: 1;
}

.winners-list {
  position: relative;
  overflow: hidden;
  height: 600px; /* 或者指定具体高度，如 400px */
  width: 100%;
  border: 1px solid #ccc; /* 边框较细 */
  background-color: #fff; /* 背景颜色 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* 添加阴影 */
  padding: 10px; /* 内边距 */
}

.title-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background-color: rgb(147, 147, 10); /* 标题背景颜色 */
  color: #fff; /* 标题文字颜色 */
  padding: 10px; /* 内边距 */
  text-align: center; /* 文字居中 */
  z-index: 1; /* 确保标题在最上面 */
}

.title-container::after {
  content: "";
  display: block;
  width: 60%; /* 线的宽度 */
  height: 1px; /* 线的高度 */
  background-color: #ccc; /* 线的颜色 */
  margin: 0 auto; /* 居中 */
}

.scrolling-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: scrollText 15s linear infinite;
  padding-top: 50px; /* 为标题留出空间 */
}

.winner-item {
  display: block;
  padding: 5px 10px;
  margin-bottom: 10px;
  background-color: #f5f5f5;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); /* 添加阴影 */
}

.user-id,
.prize {
  margin-right: 10px;
}

@keyframes scrollText {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(-100%);
  }
}
</style>